import React from 'react';
import { GoogleButton } from '../../../components/GoogleButton';
import Styles from './GoogleLogin.module.less';
import { handleGoogleSuccess } from '../../user/googleHandlers';
import { Wrapper } from '../Wrapper';
import { addQueryParamsToUrl, voidFn } from '../../../lib';
import { useLandingCTAQueryParam } from '../../../lib/landingPage';
import { APP_BASE_URL } from '../../../config';

export type GoogleLoginProps = {
    text: string;
    url: string;
};

export const GoogleLogin = Wrapper(({ url }: GoogleLoginProps): JSX.Element => {
    const pageParams = useLandingCTAQueryParam();
    const pageFullUrl = new URL(addQueryParamsToUrl(url, pageParams ?? {}));
    const pagePath = pageFullUrl.pathname + pageFullUrl.search;

    const redirectFn = (url: string) =>
        (window.location.href = APP_BASE_URL + url);
    const ref = React.useRef<HTMLSpanElement>(null);
    const [width, setWidth] = React.useState<string>();
    React.useEffect(() => {
        setWidth(`${ref.current?.offsetWidth}`);
    }, [ref]);
    return (
        <span className="horizontal td-center-middle m-stretch-top" ref={ref}>
            <GoogleButton
                text="continue_with"
                width={width}
                className={Styles.googleButton}
                onSuccess={r =>
                    handleGoogleSuccess(r, redirectFn, { redir: pagePath })
                }
                onFailure={voidFn}
            />
        </span>
    );
}, 'googleLogin');
